<div class="aside-nav-card" [ngClass]="{'card-selected' : asideCard.isSelected}" (click)="onBtnClick()"
  [class.disabled]="!checkPermission(asideCard.permission)">
  <section class="card-image">
    <mat-icon [svgIcon]="asideCard.image"></mat-icon>
  </section>
  <section class="aside-nav-section">
    <h6 class="card-title">{{asideCard.buttonText | translate}}</h6>
    <p class="card-description">{{asideCard.description | translate}}</p>
  </section>
</div>